import React, { useContext } from 'react';

import { Styled } from './Video.styles';
import { context } from './context';
import { useSelector } from 'react-redux';
import { IRootState } from '../../../../reducer';
import { ITransportType } from '../../../../reducer/user';

export const VehicleInfo: React.FC = () => {
  const { vehicle } = useContext(context);

  const transportTypes = useSelector<IRootState, ITransportType[]>(
    (state) => state.user.transporttypes
  );

  const selectedTransportType = transportTypes.find(
    ({ code }) => code === vehicle?.routeType
  );

  return (
    <Styled.VehicleInfo>
      <p>Транспортное средство</p>
      <b>{selectedTransportType?.title}</b> <span>{vehicle?.model}</span>{' '}
      <b>{vehicle?.route}</b>
    </Styled.VehicleInfo>
  );
};
